var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"px-4 py-4"},[_c('div',{staticClass:"card-padding"},[_c('div',{staticClass:"chart"},[_c('canvas',{staticClass:"chart-canvas",attrs:{"id":'chart' + _vm.$attrs.iidd}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }